import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-providercorner',
  templateUrl: './providercorner.component.html',
  styleUrls: ['./providercorner.component.css']
})
export class ProvidercornerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }



}


